var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path!=='/print'),expression:"$route.path!=='/print'"}]}),_c('main',[_c('router-view')],1),_c('footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }